// import React, { useEffect, useState } from "react";
// import * as API from "../../utils/api.service";
// import { TOAST_ERROR } from "../../utils/common.service";

// const AboutUs = () => {
//   const [aboutUs, setAboutUs] = useState("");

//   useEffect(() => {
//     const fetchAboutUsContent = async () => {
//       try {
//         const response = await API.getAppContentApi();
//        // console.log("--------------------",response.data.about_content);

//         setAboutUs(response?.data?.about_content || "");
//       } catch (error) {
//         TOAST_ERROR("Failed to load content");
//       }
//     };

//     fetchAboutUsContent();
//   }, []);

//   return (
//     <div className="content">
//       <h1 className="d-flex justify-content-center">About Us</h1>
//       <div dangerouslySetInnerHTML={{ __html: aboutUs }} />
//     </div>
//   );
// };

// export default AboutUs;

import React, { useEffect, useState } from "react";
import * as API from "../../utils/api.service";
import { TOAST_ERROR } from "../../utils/common.service";
import { useParams } from "react-router-dom";

const AboutUs = () => {
  const { lang } = useParams();
  //console.log('pageId :', lang);
  const [aboutUs, setAboutUs] = useState("");

  useEffect(() => {
    const fetchAboutUsContent = async () => {
      try {
        const response = await API.getAppContentApi();
        // console.log("lang :", lang);
        if (lang == "ar") {
          setAboutUs(response?.data?.ar_about_content || "");
        } else {
          setAboutUs(response?.data?.about_content || "");
        }
      } catch (error) {
        TOAST_ERROR("Failed to load content");
      }
    };

    fetchAboutUsContent();
  }, [lang]);

  return (
    <div className="container">
      <div className="row">
        <div className="col">
          <div className="content" dir={lang === "ar" ? "rtl" : "ltr"}>
            <h1 className="d-flex justify-content-center mt-3 mb-3">
              {lang == "ar" ? "معلومات عنا" : "About Us"}
            </h1>
            <div dangerouslySetInnerHTML={{ __html: aboutUs }} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
